import { render, staticRenderFns } from "./PS2.vue?vue&type=template&id=6ed52c34&scoped=true&"
import script from "./PS2.vue?vue&type=script&lang=ts&"
export * from "./PS2.vue?vue&type=script&lang=ts&"
import style0 from "./PS2.vue?vue&type=style&index=0&id=6ed52c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed52c34",
  null
  
)

export default component.exports